
import _ from 'lodash';
import { PaginationRestDTO, PaginatedDataDTO, PaginationDTO } from '@bottega52/commons-pagination';
import { IDomainUserInDTO } from '../repository/jago/model/input/IDomainUserInDTO';

export function decode(data: PaginationRestDTO<IDomainUserInDTO>): PaginatedDataDTO<IDomainUserInDTO> {
    const pagination: PaginationDTO = _.omit(data, 'content');
    return {
      content: data.content,
      pagination,
    };
}
